import dayjs from "dayjs";
import styled from "styled-components";

/**
 * CLE-3015 — the visual pieces of a Clear Certified certificate, shared by the signed-in certificate
 * page (/training/certificate) and the public verification page (/certified/:credentialId).
 */

/** "October 21, 2026", in the viewer's local time. */
export const formatCertificateDate = (iso: string) =>
  dayjs(iso).format("MMMM D, YYYY");

export const Certificate = styled.section`
  position: relative;
  width: 100%;
  max-width: 860px;
  padding: 48px 40px;
  border: 3px solid var(--brand-purple-700);
  border-radius: 16px;
  background: var(--brand-white, #fff);
  text-align: center;
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.12);
`;

/**
 * The ribbon. An icon for now; John's ribbon artwork replaces the `<i>` with an SVG inside the same
 * element (`data-ribbon`), so the layout around it does not change.
 */
export const Ribbon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: var(--brand-purple-700);
  color: var(--brand-white, #fff);

  .pi-verified {
    font-size: 2.75rem;
  }
`;

export const Eyebrow = styled.div`
  color: var(--brand-gray-600);
  font-size: 0.8rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 6px 0 24px;
  color: var(--brand-purple-700);
  font-size: 2.5rem;
  font-weight: 800;
`;

export const Certifies = styled.div`
  color: var(--brand-gray-600);
`;

export const Name = styled.div`
  margin: 6px 0 8px;
  font-size: 2rem;
  font-weight: var(--font-weight-semibold, 600);
`;

export const Hospital = styled.div`
  margin-bottom: 20px;
  font-size: 1.1rem;
`;

export const Body = styled.p`
  margin: 0 auto 20px;
  max-width: 460px;
  color: var(--brand-gray-600);
`;

export const DateLine = styled.div`
  font-weight: var(--font-weight-semibold, 600);
`;

export const Version = styled.div`
  position: absolute;
  right: 16px;
  bottom: 10px;
  color: var(--brand-gray-600);
  font-size: 0.7rem;
`;
